import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GwcApiConnService } from './gwc-api-conn.service';

type ResolvePricingParams = {
    regalia_id: string;
    base_price?: number | null;
    institution_id?: string | null;
    effective_on?: string | null;
    list_regalia_cat_id?: string | null;
    list_regalia_sub_cat_id?: string | null;
};

export interface CasualHirePricingResolution {
    modifier_amount: number;
    currency: string;
    final_price: number | null;
    modifier: any;
}

@Injectable({ providedIn: 'root' })
export class GwcApiCasualHirePricingService {
    constructor(private _gwcApiConnService: GwcApiConnService) {}

    resolve(params: ResolvePricingParams): Observable<CasualHirePricingResolution> {
        const query: Record<string, string> = {
            regalia_id: params.regalia_id,
        };

        if (params.base_price !== undefined && params.base_price !== null) {
            query['base_price'] = params.base_price.toString();
        }

        if (params.institution_id) {
            query['institution_id'] = params.institution_id;
        }

        if (params.effective_on) {
            query['effective_on'] = params.effective_on;
        }

        if (params.list_regalia_cat_id) {
            query['list_regalia_cat_id'] = params.list_regalia_cat_id;
        }

        if (params.list_regalia_sub_cat_id) {
            query['list_regalia_sub_cat_id'] = params.list_regalia_sub_cat_id;
        }

        return this._gwcApiConnService
            .request('GET', ['v2', 'casual-hire-pricing', 'resolve'], query) as Observable<CasualHirePricingResolution>;
    }
}
